<template>
<div>

    <el-crud :baseUrl="'/employees/'+id+'/permissions'" 
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        :filters="filters"
        ref="crud">


        <template slot="crudFiltersDescription">
            <div>Fecha: <strong>{{filters.date_from}}</strong> a <strong>{{filters.date_to}}</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <el-form-item label="Fechas" prop="date_range" required :rules="[{required: true, message: 'Campo requerido'}]">
                <el-date-picker
                    v-model="filters.date_range"
                    type="daterange"
                    @change="dateRangePickerChange"
                    format="yyyy-MM-dd"
                    align="right"
                    placeholder="Seleccione una fecha">
                </el-date-picker>                
            </el-form-item>
        </template>

        <template slot="table">
            <el-table-column
                prop="datetime_from"
                label="Desde">
            </el-table-column>
            <el-table-column
                prop="datetime_to"
                label="Hasta">
            </el-table-column>
            <el-table-column
                prop="excuse.description"
                label="Tipo">
            </el-table-column>
            <!-- <el-table-column
                align="center"
                label="Justificada">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.justified" type="success" size="mini">Si</el-tag>
                    <el-tag v-else type="danger" size="mini">No</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="Remunerada">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.paid" type="success" size="mini">Si</el-tag>
                    <el-tag v-else type="danger" size="mini">No</el-tag>
                </template>
            </el-table-column> -->
            <el-table-column
                label="Observaciones">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.observations != null && scope.row.observations.length > 10" class="item" effect="dark" :content="scope.row.observations" placement="top"><span>{{ scope.row.observations.substring(0, 10) }}...</span></el-tooltip>
                    <span v-else>{{ scope.row.observations }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="authorizer.name"
                label="Autorizador">
            </el-table-column>
            <el-table-column
                prop="updated_at"
                label="Fecha">
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Desde" label-width="140px">
                <el-date-picker
                    v-model="resource.datetime_from.value"
                    type="datetime"
                    placeholder="Fecha y hora">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="Hasta" label-width="140px">
                <el-date-picker
                    v-model="resource.datetime_to.value"
                    type="datetime"
                    placeholder="Fecha y hora">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="Tipo" label-width="140px" :error="scope.errors.excuse_id">
                <el-select v-model="resource.excuse_id" filterable placeholder="Seleccione" size="mini">
                    <el-option
                        v-for="item in excuses"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="Justificada" label-width="120px" :prop="resource.justified.value" :error="scope.errors.justified">
                <el-radio-group v-model="resource.justified.value">
                    <el-radio-button label="Si" size="small"></el-radio-button>
                    <el-radio-button label="No" size="small"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="Remunerada" label-width="120px" :prop="resource.paid.value" :error="scope.errors.paid">
                <el-radio-group v-model="resource.paid.value">
                    <el-radio-button label="Si" size="small"></el-radio-button>
                    <el-radio-button label="No" size="small"></el-radio-button>
                </el-radio-group>
            </el-form-item> -->
            <el-form-item label="Observaciones" label-width="140px">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="Observaciones"
                    v-model="resource.observations">
                </el-input>
            </el-form-item>
        </template>
    
    </el-crud>

</div>
</template>

<style>
table.details td {
    padding-left: 3px;
    padding-right: 3px;
    font-size: 11px;
    line-height: 1.3em;
    height: 15px;
}
</style>

<script>
    import { mapGetters, mapActions } from "vuex";
    import el_crud from '../el-crud.vue';
    export default {
        name: 'employee-excuses',
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                crudConfig:{
                    level: 'L2',
                    AddItemTitle: 'Agregar permiso',
                    EditItemTitle: 'Editar permiso',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el permiso. Desea continuar?'
                },
                resource: {
                    datetime_from: {
                        value: '',
                        setValue: (value) => {
                            this.resource.datetime_from.value = (value) ? value.datetime_from : null;
                        },
                        getValue: () => {
                            return moment(this.resource.datetime_from.value).format('YYYY-MM-DD HH:mm:SS');
                        }
                    },
                    datetime_to: {
                        value: '',
                        setValue: (value) => {
                            this.resource.datetime_to.value = (value) ? value.datetime_to : null;
                        },
                        getValue: () => {
                            return moment(this.resource.datetime_to.value).format('YYYY-MM-DD HH:mm:SS');
                        }
                    },
                    excuse_id: null,
                    // justified: {
                    //     value: '',
                    //     setValue: (value) => {
                    //         this.resource.justified.value = (value && value.justified) ? 'Si' : 'No';
                    //     },
                    //     getValue: () => {
                    //         return this.resource.justified.value === 'Si';
                    //     }
                    // },
                    // paid: {
                    //     value: '',
                    //     setValue: (value) => {
                    //         this.resource.paid.value = (value && value.paid) ? 'Si' : 'No';
                    //     },
                    //     getValue: () => {
                    //         return this.resource.paid.value === 'Si';
                    //     }
                    // },
                    status: {
                        value: '',
                        setValue: (value) => {
                            this.resource.status.value = 'APR';
                        },
                        getValue: () => {
                            return 'APR';
                        }
                    },
                    observations: null,
                },
                filters: {
                    date_range: null,
                    date_from: null,
                    date_to: null,
                },
            };
        },
        components: {
            'el-crud': el_crud,
        },
        mounted() {
            this.fetchExcuses();
        },
        computed: {
            ...mapGetters(["excuses"]),
        },
        methods: {
            ...mapActions(["fetchExcuses"]),
            dateRangePickerChange () {
                let value = this.filters.date_range;
                // console.log(value);
                this.filters.date_from = moment(value[0]).format('YYYY-MM-DD');
                this.filters.date_to = moment(value[1]).format('YYYY-MM-DD');
            },
        }
    }
</script>
